import { render } from "./KomisiKomisi.vue?vue&type=template&id=e165c98a"
import script from "./KomisiKomisi.vue?vue&type=script&lang=js"
export * from "./KomisiKomisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__